/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationGroupRequestSchema } from "./comboCalculationGroupRequestSchema.ts";

export const comboCalculationDetailRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	groups: z.array(comboCalculationGroupRequestSchema),
	front_item_id: z.uuid().nullish(),
});
